import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-circularArc",
  "use": "icon-circularArc-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-circularArc\"><path d=\"M952.32 921.6h-61.44c0-434.79-353.69-788.48-788.48-788.48V71.68c468.634 0 849.92 381.286 849.92 849.92z\" opacity=\".5\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol